import React, { Fragment } from 'react'
import { useShared } from '../../hooks/useShared'
import MainSection from '../../components/sections/MainSection';
import APopover from '../../components/partials/APopover';


const TABLE_HEAD = ["#", "نام/شرکت", 'اجانس', 'مقدرا بول', 'تاريخ ایجاد'];
const breadcrumbs = [{ name: 'عوايد', link: '/tariffs' }]

const searchInputFields = [
    { label:  "نام/شرکت", name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3',},
    { label: 'جنس', name: 'item',type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3',  },

];

export default function Incomes() {


    const { com,models,  } = useShared();

    const getTableData = () => {
        const data = models?.data
        return (<><tbody className=' '>

            {data?.map((r, i) => {
                return (<Fragment key={r.id}>
                    {i < data?.length - 1 && <tr key={r.id} >
                        <td >{models?.from + i}</td>
                        <th className='text-left px-2'>{r?.company ? r?.company?.name_af : r?.name}</th>

                        <td style={{ direction: 'rtl' }}>
                            {r?.itemss?.map((item, j) => {
                                return <span key={j} className='ml-1'>{item?.category?.label}{j < r?.itemss?.length - 1 && <span >،</span>} </span>
                            })}
                            <APopover v={{ data: itemsPopup(r?.itemss), className: "mt-3" }} />
                        </td>

                        <td  style={{direction:'ltr'}}> {com.NumberFormatter(r?.amount)} ؋</td>

                        <td  style={{direction:'ltr'}}  className='w-[20%]'>{com.dateConvert(r?.updated_at,false, true)}</td>

                    </tr>}</Fragment>
                )
            })}

        </tbody>
            <tfoot>
                {data?.length > 0 && <tr className='border' key={data[data?.length - 1]?.id}>
                    <th className="bg-purple-500/20 text-purple-900"> توتال</th>
                    <th colSpan={4} className=" bg-green-400/30 text-green-900 text-lg font-bold">{com.NumberFormatter(data[data?.length - 1]?.amount)} ؋</th>
                </tr>}
            </tfoot>
        </>)
    }


    const itemsPopup = (items) => <table style={{ direction: 'rtl' }} className=" gTable  ">
        <thead >
            <tr  className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                <th>#</th>
                <th>نام جنس</th>
                <th> مقدار پول</th>
            </tr>
        </thead>
        <tbody >
            {items?.map((item, i) => (
                <tr key={i + 1}>
                    <td>{1 + i}</td>
                    <td>{item?.category?.label} </td>
                    <td> {item?.tariff_amount} ؋</td>

                </tr>
            ))}
        </tbody>
    </table>




    return (
            <MainSection v={{
                searchInputFields,
                TABLE_HEAD,
                tableData: getTableData(),
                breadcrumbs,
                tableTitle: 'لست عوايد',
                mUrl: { getAll: 'incomes' },

            }} />
    )
}
